import React from 'react';
import '../CSS/UserProfilePage.css';

/**
 * Reusable Profile Avatar (DP) component.
 * Renders a circular avatar with the user's first initial,
 * styled with the site's light-teal theme.
 *
 * @param {string} name     - The user's display name.
 * @param {number} size     - Diameter in px (default: 55).
 * @param {number} fontSize - Font size for the initial (default: 22).
 */
const ProfileAvatar = ({ name, size = 55, fontSize = 22 }) => {
  const initial = name ? name.charAt(0).toUpperCase() : 'U';

  return (
    <div
      className="profile-avatar-dp"
      style={{ width: size, height: size, fontSize }}
      aria-label={`Avatar for ${name || 'User'}`}
    >
      {initial}
    </div>
  );
};

export default ProfileAvatar;
